__turbopack_context__.v({
  "is-scrolling": "MarqueeText-module__eiGNkW__is-scrolling",
  "marquee-bounce": "MarqueeText-module__eiGNkW__marquee-bounce",
  "marquee-fade": "MarqueeText-module__eiGNkW__marquee-fade",
  "marquee-inner": "MarqueeText-module__eiGNkW__marquee-inner",
  "marquee-track": "MarqueeText-module__eiGNkW__marquee-track",
});
